import { Grid, GridColumn } from '@progress/kendo-react-grid'
import * as React from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import * as Redux from 'redux'
import * as RasaHelp from '../../../components/help'
import * as RasaModal from '../../../components/modal'
import * as RasaInput from '../../../components/rasa-input'
import * as Sortable from '../../../components/sortable'
import * as GridCell from '../../grid-cell'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Render from './render'
import './styles.css'
import * as Types from './types'
import * as Utils from './utils'

class ActiveCell extends GridCell.ActiveCell {
  constructor(props: any) {
    super(props, props.dataItem.updateStatusEvent)
  }
}

interface DispatchProps {
  modalPopulator: Actions.ModalPopulator,
  showModal: RasaModal.Toggle,
}

const filtersWithKey = (filters: Types.Filter[], updateStatusEvent: string) =>
  filters.map( (f) => ({
    ...f,
    updateStatusEvent,
  }))

interface GridComponentProps {
  dispatch: Redux.Dispatch<Redux.Action>,
  filterType: Types.FilterType,
  sourceType: Types.SourceType,
}

const TagTable =
  ({dispatch, filters, filterType, sourceType}: GridComponentProps & Types.WrappedFilterState) =>
  <Grid data={filtersWithKey(filters.data, Utils.updateStatusEvent(filterType, sourceType))}
  sortable={{
    allowUnsort: true,
    mode: 'multiple',
  }}
  sort={filters.view.sort}
  onSortChange={(e) => dispatch({
                        options: { value: e.sort },
                        type: Sortable.sortTableConstant(Utils.requestEvent(filterType, sourceType)),
  })}>
  <GridColumn field="tag" title="Tag"/>
  <GridColumn cell={ActiveCell} field="is_active" title="Active"/>
</Grid>

const GroupTable =
  ({dispatch, filters, filterType, sourceType}: GridComponentProps & Types.WrappedFilterState) =>
  <Grid data={filtersWithKey(filters.data, Utils.updateStatusEvent(filterType, sourceType))}
        sortable={{
          allowUnsort: true,
          mode: 'multiple',
        }}
        sort={filters.view.sort}
        onSortChange={(e) => dispatch({
                        options: { value: e.sort },
                        type: Sortable.sortTableConstant(Utils.requestEvent(filterType, sourceType)),
        })}>
  <GridColumn field="group_name" title="Name"/>
  <GridColumn cell={Render.TagsCell} field="tag" title="Tags" sortable={false} />
  <GridColumn cell={Render.ActiveCell} field="is_active" title="Active" width={75} />
</Grid>

interface GridProps {
  dispatch: Redux.Dispatch<Redux.Action>,
  filterType: Types.FilterType,
  helpType?: string,
  label?: string,
  sourceType: Types.SourceType,
}
type Props = Types.WrappedFilterState & GridProps & DispatchProps

const GridComponent =
  ({filters, filterType, helpType, modalPopulator, showModal, sourceType, label, dispatch}: Props) =>
  <div className="filter-grid">
    <div className="page-header-container">
      <span className="page-header">
      <span>{label}</span>
      {helpType && <RasaHelp.Help helpType={helpType} id={Utils.updateStatusEvent(filterType, sourceType)}/>}
      </span>
      <Button className="secondary-button"
              onClick={() =>
                dispatch(modalPopulator(filterType, sourceType)) &&
                dispatch(showModal())
              }>Add</Button>
    </div>
    <div>
    {filters.data.length === 0
    ?
      <span>No {label} records defined.</span>
    :
      <RasaInput.RasaCollapse label={`Show ${filters.data.length} ${label} records`}>
        {sourceType === Constants.SOURCE_GROUP
        ?
        <GroupTable filters={filters} filterType={filterType} sourceType={sourceType} dispatch={dispatch} />
        :
        <TagTable filters={filters} filterType={filterType} sourceType={sourceType} dispatch={dispatch} />
        }
      </RasaInput.RasaCollapse>}
    </div>
  </div>

export const FilterGrid = connect(
  null,
  (dispatch) => ({
    dispatch,
    modalPopulator: Actions.modalPopulator,
    showModal: Actions.toggleModal,
  }))(GridComponent)



// WEBPACK FOOTER //
// ./src/pages/source-config/filters/components.tsx